import React, { useState } from 'react';
import { useEffect } from 'react';
import { useSelector } from "react-redux";

const genderOptions = [
  'Male',
  'Female',
  'Non-binary',
];

const StepPersonalInfo = ({ data, onChange, onNext, loading = false, error }) => {
  const [localError, setLocalError] = useState('');
  const user = useSelector((state) => state?.user);

  const userName = user.user?.username;

  useEffect(() => {
    if (userName) {
      const nameParts = userName.trim().split(' ');
      if (nameParts.length >= 2) {
        onChange('firstName', nameParts[0]);
        onChange('lastName', nameParts.slice(1).join(' '));
      } else if (nameParts.length === 1) {
        onChange('firstName', nameParts[0]);
      }
    }
  }, [userName]);

  const isTherapist = !data.providerType || data.providerType === 'Therapist';

  const handleNext = (e) => {
    e.preventDefault();
    if (isTherapist) {
      if (!data.firstName || !data.lastName || !data.yearsOfExperience || !data.gender) {
        setLocalError('All fields are required.');
        return;
      }
    } else {
      if (!data.firstName || !data.lastName) {
        setLocalError('First Name and Last Name are required.');
        return;
      }
    }
    setLocalError('');
    onNext(data, () => { }); // pass data to parent for API call
  };

  return (
    <form onSubmit={handleNext} style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
      <div style={{ fontSize: 32, marginBottom: 8 }}>
        <svg width="81" height="81" viewBox="0 0 81 81" fill="none" xmlns="http://www.w3.org/2000/svg">
          <g clipPath="url(#clip0_10605_453)">
            <path fillRule="evenodd" clipRule="evenodd" d="M7.59375 18.2812C7.59375 12.2234 12.5046 7.3125 18.5625 7.3125H62.4375C68.4955 7.3125 73.4062 12.2234 73.4062 18.2812V62.1562C73.4062 68.2143 68.4955 73.125 62.4375 73.125H47.3317L43.5424 78.8094C42.8641 79.8265 41.7226 80.4375 40.5 80.4375C39.2773 80.4375 38.1359 79.8265 37.4576 78.8094L33.6683 73.125H18.5625C12.5046 73.125 7.59375 68.2143 7.59375 62.1562V18.2812ZM30.8743 31.5767C30.8743 26.2609 35.1761 21.9375 40.5 21.9375C45.8239 21.9375 50.1254 26.2609 50.1254 31.5767C50.1254 36.8923 45.8239 41.2158 40.5 41.2158C35.1761 41.2158 30.8743 36.8923 30.8743 31.5767ZM22.2915 57.7742C24.0116 49.2815 31.5008 42.8779 40.5 42.8779C49.4991 42.8779 56.9886 49.2815 58.7085 57.7742C58.9264 58.8492 58.6496 59.9654 57.9553 60.8144C57.261 61.6637 56.2219 62.1562 55.125 62.1562H25.875C24.7781 62.1562 23.7391 61.6637 23.0447 60.8144C22.3502 59.9654 22.0738 58.8492 22.2915 57.7742Z" fill="#27B99A" />
          </g>
          <defs>
            <clipPath id="clip0_10605_453">
              <rect width="81" height="81" fill="white" />
            </clipPath>
          </defs>
        </svg>
      </div>
      <h2 style={{
        margin: 0,
        fontFamily: 'Poppins, sans-serif',
        fontWeight: 700,
        fontStyle: 'bold',
        fontSize: 28,
        lineHeight: '150%',
        letterSpacing: 0,
        verticalAlign: 'middle',
      }}>
        Confirm Personal Information
      </h2>
      <input
        type="text"
        placeholder="First Name"
        value={data.firstName}
        onChange={e => onChange('firstName', e.target.value)}
        style={{ padding: 12, borderRadius: 6, border: '1px solid #eee' }}
      />
      <input
        type="text"
        placeholder="Last Name"
        value={data.lastName}
        onChange={e => onChange('lastName', e.target.value)}
        style={{ padding: 12, borderRadius: 6, border: '1px solid #eee' }}
      />
      {isTherapist && (
        <>
          <select
            value={data.gender}
            onChange={e => onChange('gender', e.target.value)}
            style={{ padding: 12, borderRadius: 6, border: '1px solid #eee' }}
          >
            <option value="">Select Gender</option>
            {genderOptions.map(opt => (
              <option key={opt} value={opt}>{opt}</option>
            ))}
          </select>
          <input
            type="number"
            placeholder="Years of Experience"
            value={data.yearsOfExperience}
            onChange={e => onChange('yearsOfExperience', e.target.value)}
            style={{ padding: 12, borderRadius: 6, border: '1px solid #eee' }}
            min={0}
          />
        </>
      )}
      <div style={{ display: 'flex', flexDirection: 'column', gap: 4 }}>
        <label style={{ fontSize: 12, color: '#666', marginLeft: 4 }}>Provider Type (Assigned by Admin)</label>
        <input
          type="text"
          value={data.providerType === null ? 'Loading...' : (data.providerType || 'Therapist')}
          disabled
          style={{ padding: 12, borderRadius: 6, border: '1px solid #eee', backgroundColor: '#f9f9f9', cursor: 'not-allowed' }}
        />
      </div>
      {/* <input
        type="number"
        placeholder="Fee"
        value={data.fees}
        onChange={e => onChange('fees', e.target.value)}
        style={{ padding: 12, borderRadius: 6, border: '1px solid #eee', marginTop: 12 }}
        min={0}
        step="0.01"
      /> */}
      {(localError || error) && <div style={{ color: 'red', fontSize: 14 }}>{localError || error}</div>}
      <button
        type="submit"
        style={{
          marginTop: 32,
          padding: 0,
          background: 'none',
          border: 'none',
          cursor: loading ? 'not-allowed' : 'pointer',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'flex-start',
          opacity: loading ? 0.6 : 1,
        }}
        disabled={loading}
      >
        <div style={{
          display: 'flex',
          alignItems: 'center',
          background: loading ? '#5a8c9e' : '#07405A',
          borderRadius: 8,
          boxShadow: '0px 4px 12px 0px rgba(7, 64, 90, 0.10)',
          padding: '0 24px 0 24px',
          height: 48,
          minWidth: 160,
          gap: 10,
          position: 'relative',
        }}>
          <span style={{
            color: '#fff',
            fontWeight: 700,
            fontSize: 16,
            fontFamily: 'inherit',
            marginRight: 24,
          }}>
            {loading ? 'Saving...' : 'Next'}
          </span>
          <span style={{ position: 'absolute', right: 10 }}>
            <svg width="37" height="37" viewBox="0 0 37 37" fill="none" xmlns="http://www.w3.org/2000/svg">
              <circle cx="18.3673" cy="18.3673" r="17.8673" fill="white" fillOpacity="0.1" stroke="white" />
              <path d="M17.993 11.995L24.7402 18.7421L17.993 24.7396" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
              <path opacity="0.5" d="M13 13.7257L18.2478 18.8853L13 23.4716" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
          </span>
        </div>
      </button>
    </form>
  );
};

export default StepPersonalInfo; 